import { createStore } from '@aibees/shared/store';
import { LabelsMetadataStoreData as StoreData } from './types';

const useLabelsMetadataStore = createStore<StoreData>(
  'labels-metadata',
  (set) => ({
    metadata: undefined,
    setMetadata: (metadata) => set({ metadata }),
  })
);

export default useLabelsMetadataStore;
